import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import active from '../assets/Dashboard/active.svg';
import inactive from '../assets/Dashboard/inactive.svg';
import trial from '../assets/Dashboard/trial.svg';
import invited from '../assets/Dashboard/invited.svg';
import request from '../assets/Dashboard/request.svg';
import process from "../assets/Dashboard/process.svg";
import overdue from "../assets/Dashboard/overdue.svg";
import close from "../assets/Dashboard/close.svg";
import open1 from "../assets/Dashboard/open1.svg";
import reopen from "../assets/Dashboard/reopen.svg";
import received from "../assets/Wallet/received.svg";
import pending from "../assets/Wallet/pending.svg";
import { useTranslation } from "react-i18next";
import badge from "../assets/Dashboard/badge.svg"

const ArrowStatusDropdown = ({ currentStatus, onChange, statusOptions = [],showArrow = false }) => {

  const statusIcons = {
    Active: active,
    resolved: active,
    active: active,
    Trial: overdue,
    trial: overdue,
    Invited: invited,
    new: invited,
    invited: invited,
    Inactive: inactive,
    escalated: inactive,
    inactive: inactive,
    Requested: request,
    requested: request,
    Overdue: overdue,
    Processing: process,
    initiated: process,
    Paid: active,
    paid: active,
    Pending: pending,
    pending: pending,
    Received: active,
    received: active,
    Verified: active,
    verified: active,
    Blocked: inactive,
    blocked: inactive,
    rejected: inactive,
    success: active,
    in_progress: trial,
    failed: inactive,
    unclaimed: trial,
    returned: active,
    low: badge,
    medium: badge,
    high: badge,
    critical: badge,
    closed: close,
    open: open1,
    reopened: reopen
  };

  const statusStyles = {
    Active: { backgroundColor: '#4BCE97', color: '#164B35' },
    resolved: { backgroundColor: '#4BCE97', color: '#164B35' },
    active: { backgroundColor: '#4BCE97', color: '#164B35' },
    success: { backgroundColor: '#4BCE97', color: '#164B35' },
    Trial: { backgroundColor: '#FEA362', color: '#702E00' },
    high: { backgroundColor: '#FEA362', color: '#702E00' },
    in_progress: { backgroundColor: '#FEA362', color: '#702E00' },
    reopened: { backgroundColor: '#57D5FF', color: '#095C6C' },
    closed: { backgroundColor: '#C1F2A0', color: '#215922' },
    low: { backgroundColor: '#BCBFC2', color: '#44546F' },
    Invited: { backgroundColor: '#579DFF', color: '#09326C' },
    new: { backgroundColor: '#579DFF', color: '#09326C' },
    medium: { backgroundColor: '#579DFF', color: '#09326C' },
    invited: { backgroundColor: '#579DFF', color: '#09326C' },
    Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
    escalated: { backgroundColor: '#F87168', color: '#5D1F1A' },
    critical: { backgroundColor: '#F87168', color: '#5D1F1A' },
    inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
    Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    open: { backgroundColor: '#F5CD47', color: '#533F04' },
    requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
    Overdue: { backgroundColor: '#FFA26B', color: '#722800' },
    Pending: { backgroundColor: '#F5CD47', color: '#533F04' },
    pending: { backgroundColor: '#F5CD47', color: '#533F04' },
    Received: { backgroundColor: '#4BCE97', color: '#164B35' },
    received: { backgroundColor: '#4BCE97', color: '#164B35' },
    Verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
    verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
    Blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
    blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
    rejected: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
    initiated: { backgroundColor: '#FDD35C', color: '#7A4100' },
    failed: { backgroundColor: '#F87168', color: '#5D1F1A' },
    trial: { backgroundColor: '#FEA362', color: '#702E00' },
    unclaimed: { backgroundColor: '#FEA362', color: '#702E00' },
    returned: { backgroundColor: '#4BCE97', color: '#164B35' },
  };

  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // ✅ Always open the dropdown
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) onChange(status);
    setAnchorEl(null);
  };

  const displayStatusLabels = {
    initiated: 'Processing',
    success: 'Paid',
    failed: 'Failed',
    // Add other overrides if needed
  };

  // Helper to get localized label for a status
  const getLocalizedStatus = (status) => {
    // Use displayStatusLabels for overrides, else use status as is
    const key = displayStatusLabels[status] || status;
    return t(`statuses.${key}`) || key;
  };

  return (
    <>
      <Box
        onClick={handleClick}
        // sx={{
        //   display: 'flex',
        //   alignItems: 'center',
        //   gap: 0.5,
        //   px: 0.4,
        //   py: 0.4,
        //   borderRadius: '4px',
        //   fontWeight: 400,
        //   fontFamily: 'Poppins, sans-serif',
        //   fontSize: '13px',
        //   cursor: 'pointer', // ✅ always pointer
        //   width: 'fit-content',
        //   ...statusStyles[currentStatus]
        // }}
                  sx={{ display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 1,
    py: 0.4,
    borderRadius: "6px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    // cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

    // 🌍 Responsive equal width logic
    flex: 1,                            // take full space inside table cell
    maxWidth: 120,                      // prevent overflow
    minWidth: 110,                      // ensure equal base size
    width: "100%",                      // allow auto-fit
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    ...statusStyles[currentStatus]
        }}
      >
        <img src={statusIcons[currentStatus]} alt={currentStatus} style={{ width: 16, height: 16 }} />

        <Typography sx={{ fontSize: '13px', color: (statusStyles[currentStatus]?.color || '#333333') }}>
          {getLocalizedStatus(currentStatus)}
        </Typography>

        {/* ✅ Always show dropdown icon */}
        {showArrow && (
        <ArrowDropDownIcon sx={{ fontSize: 18, color: statusStyles[currentStatus]?.color }} />
        )}
      </Box>

  <Menu
  anchorEl={anchorEl}
  open={open}
  onClose={() => handleClose(null)}
  PaperProps={{
    sx: {
      minWidth: 110,   // smaller menu
      padding: 0,      // remove default padding
    }
  }}
>
  {statusOptions.map((status) => (
    <MenuItem
      key={status}
      onClick={() => handleClose(status)}
      sx={{
        px: 0.8,        // tighter left/right spacing
        py: 0.6,        // compact height
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.6,     // reduce gap between icon & text
        }}
      >
        <img
          src={statusIcons[status]}
          alt={status}
          style={{ width: 16, height: 16 }}
        />

        <Typography
          sx={{
            fontSize: "13px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {getLocalizedStatus(status)}
        </Typography>
      </Box>
    </MenuItem>
  ))}
</Menu>

    </>
  );
};

export default ArrowStatusDropdown;
